import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { Address } from 'services/AddressesService';
import useUserCityPosition from 'hooks/useUserCity';

type LatLngLiteral = google.maps.LatLngLiteral;

interface DeliveryMapProps {
  selected?: number;
  alternatives?: Address[];
  setSelectedAlternative: (index: number) => void;
}

const mapContainerStyle = {
  width: '100%',
  height: '100%',
};

const DeliveryMap: React.FC<DeliveryMapProps> = ({
  selected,
  alternatives,
  setSelectedAlternative,
}) => {
  const { lat, lng } = useUserCityPosition();
  const defaultCenter: LatLngLiteral = { lat, lng };
  const focusedAddress: Address | undefined = alternatives?.at(selected || 0);
  const center: LatLngLiteral = (() => {
    if (focusedAddress?.lat != null && focusedAddress?.lng != null) {
      return { lat: focusedAddress.lat, lng: focusedAddress.lng };
    }
    return defaultCenter;
  })();

  const hasValidCoordinates =
    focusedAddress?.lat != null && focusedAddress?.lng != null;

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={hasValidCoordinates ? 16 : 11}
      >
        {alternatives?.map((address, index) => {
          if (address.lat == null || address.lng == null) return null;
          return (
            <Marker
              key={index}
              position={{ lat: address.lat, lng: address.lng }}
              onClick={() => setSelectedAlternative(index)}
            />
          );
        })}
      </GoogleMap>
    </div>
  );
};

export default DeliveryMap;
